// Košík v hlavičke — slovenské dvojče locale/cs/cartCounter.js.
export default {
  eyebrow: 'Košík',
  empty: 'Prázdny',
};
